module.exports = __webpack_public_path__ + "static/componentsOrTextStylesYes-7d32d3193e70d69eb14003251b19755a.png";